// extracted by mini-css-extract-plugin
export default {"container":"Blog_screen_container__tlijP"};